import { ExclamationCircle } from "@ignite-analytics/icons";
import { Box, CircularProgress, Container, type ContainerProps, Stack, Typography } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";

import type { SaveStatus } from "../../hooks/useSaveAnswersV2";
import { LanguageSwitcher } from "../LanguageSwitcher";

type Props = {
    start?: React.ReactNode;
    maxWidth?: ContainerProps["maxWidth"];
    translating?: boolean;
};

export const QuestionnaireTopBar: React.FC<Props> = ({ start, maxWidth = "md", translating }) => (
    <Box
        sx={{
            position: "sticky",
            top: 0,
            zIndex: (theme) => theme.zIndex.appBar,
            bgcolor: "background.paper",
            borderBottom: "1px solid",
            borderColor: "divider",
        }}
    >
        <Container maxWidth={maxWidth}>
            <Stack direction="row" spacing={2} sx={{ alignItems: "center", justifyContent: "space-between", py: 1 }}>
                <Box sx={{ minWidth: 0 }}>{start}</Box>
                <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
                    {translating && (
                        <Stack direction="row" spacing={1} aria-live="polite" sx={{ alignItems: "center" }}>
                            <CircularProgress size={14} thickness={5} />
                            <Typography variant="textSm" color="textTextSecondary">
                                <FormattedMessage defaultMessage="Translating…" />
                            </Typography>
                        </Stack>
                    )}
                    <LanguageSwitcher />
                </Stack>
            </Stack>
        </Container>
    </Box>
);

export const SaveIndicator: React.FC<{ status: SaveStatus }> = ({ status }) => (
    <Stack direction="row" spacing={1} aria-live="polite" sx={{ alignItems: "center", minHeight: 20 }}>
        {status === "error" && (
            <>
                <ExclamationCircle fontSize="small" color="error" />
                <Typography variant="textSm" color="textTextError">
                    <FormattedMessage defaultMessage="Some answers are not saved" />
                </Typography>
            </>
        )}
    </Stack>
);
